module.exports = __webpack_public_path__ + "img/edit_bg.db6d6616.png";